const defeats = [
  {
    title: "Ну как же так!",
    text:
      "Похоже, наушники выпали и остались лежать на дороге. С JBL TUNE 225TWS в удобном для города форм-факторе вкладышей этого бы точно не случилось: они отлично держатся.\nПопробуем еще раз?",
  },

  {
    title: "О, нет! Села батарея",
    text:
      "У наушников села батарея. Видимо, это были не JBL TUNE 225 TWS, которые могут непрерывно работать до 5 часов, а с кейсом так и все 25! Надо попытаться снова!",
  },

  {
    title: "Это провал!",
    text:
      "Кажется, просто нажали не ту кнопку. А вот с JBL TUNE 225 TWS все просто - у них настоящие, физические кнопки, с такими не ошибешься. Может, повторим?",
  },

  {
    title: "Ой, поиски второго наушника отвлекли от задачи",
    text:
      "А ведь у JBL TUNE 225 TWS вообще можно не использовать второй: они работают и по одному, потому что в каждом есть микрофон. Еще одна попытка!",
  },

  {
    title: "Все пропало!",
    text:
      "Как и соединение со смартфоном. Жаль, что это были не  JBL TUNE 225 TWS: они мгновенно подключаются к устройству за счет технологии Fast Pair и обеспечивают стабильную связь. Надо попробовать еще раз!",
  },
];

const victories = [
  {
    title: "У вас получилось!",
    text:
      "Вы точь-в-точь как JBL TUNE 225 TWS: удобные, с мощными басами и легендарным звучанием JBL. Давайте посмотрим, на что вы еще способны: получите промокод и попробуйте пройти игру на других уровнях.",
  },

  {
    title: "Вы сделали это!",
    text:
      "Мы верили в вас, как в JBL TUNE 225 TWS – полностью беспроводные наушники, готовые работать и работать до 5 часов без подзарядки (а с кейсом так и все 25). Получите промокод и попробуйте поиграть на других уровне.",
  },

  {
    title: "Как вам это удалось?",
    text:
      "Впрочем, у всех свои секреты – например, JBL TUNE 225 TWS тоже не расскажут, как им удается передавать чистое звучание и мощные басы. Ваш промокод здесь, но вы способны на большее: пройдите игру на других уровнях.",
  },

  {
    title: "Вы настоящий профи!",
    text:
      "Это хорошо, когда все настоящее: вот у JBL TUNE 225 TWS кнопки тоже настоящие, физические. А вот проводов нет, ни единого. Попробуйте сыграть еще раз, выбрав другой уровень – и не забудьте получить промокод.",
  },

  {
    title: "Задача выполнена!",
    text:
      "Вот ваш приз! Вы сделали это быстро и четко – примерно так же новые JBL TUNE 225TWS подключаются к смартфону за счет технологии Google Fast Pair. Думаем, вам и другие уровни будут по силам: попробуйте сыграть еще раз.",
  },

  {
    title: "Невероятно!",
    text:
      "Мы гордимся вами и делимся промокодом. Таких идеальных не много: вы и JBL TUNE 225TWS с легендарным звуком JBL, мощными басами и встроенными микрофонами для комфортных бесед. Хотите попробовать других уровнях?",
  },
];

export { victories, defeats };
